(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tr-section', {
                parent: 'app',
                url: '/tr-section',
                data: {
                    authorities: ['SECTION_SIDEBAR'],                    
                    pageTitle: 'trakeyeApp.section.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-section/tr-sections.html',
                        controller: 'TrSectionController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null,
                    listgeofenceid: null,
                    rangeOption : {value:'day'},
                    fromTime : null ,
                    toTime : null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            listgeofenceid: $stateParams.listgeofenceid,
                            rangeOption : $stateParams.rangeOption,
                            fromTime : $stateParams.fromTime ,
                            toTime : $stateParams.toTime
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trSection');
                        $translatePartialLoader.addPart('sectionStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-section-detail', {
                parent: 'tr-section',
                url: '/tr-section/{id}/{routeId}',
                data: {
                    authorities: ['SECTION_DETAIL'],
                    pageTitle: 'trakeyeApp.section.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-section/tr-section-detail.html',
                        controller: 'TrSectionDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trSection');
                        $translatePartialLoader.addPart('sectionStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TrSection', function ($stateParams, TrSection) {
                        return TrSection.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-section',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            .state('tr-section.priority', {
                parent: 'tr-section',
                url: '/tr-sections/priority/{priority}/{geofenceId}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.section.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-section/tr-sections.html',
                        controller: 'TrSectionController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            priority: $stateParams.priority,
                            geofenceId : $stateParams.geofenceId
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trSection');
                        $translatePartialLoader.addPart('sectionStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-section.attendance', {
                parent: 'tr-section',
                url: '/tr-sections/attendance/{login}/{fromTime}/{toTime}/{sectionStatus}',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_VENDOR', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER'],
                    pageTitle: 'trakeyeApp.section.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-section/tr-sections.html',
                        controller: 'TrSectionController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'last_modified_date,desc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            login: $stateParams.login,
                            fromTime: $stateParams.fromTime,
                            toTime: $stateParams.toTime,
                            sectionStatus: $stateParams.sectionStatus
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('trSection');
                        $translatePartialLoader.addPart('sectionStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('tr-section.new', {
                parent: 'tr-section',
                url: '/create/{lat}/{lng}/{assetdetails}/{desc}/{routeId}',
                data: {
                    authorities: ['SECTION_CREATE']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-section/tr-section-dialog.html',
                        controller: 'TrSectionDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            description: $stateParams.desc,
                            createDate: null,
                            updateDate: null,
                            pinLat: parseFloat($stateParams.lat),
                            pinLong: parseFloat($stateParams.lng),
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            sectionImages: []
                            // ,
                            // asset: {name: $stateParams.assetdetails}
                        };
                    }],

                    route : ['$stateParams', 'TrRoute', function ($stateParams, TrRoute) {

                        if($stateParams.routeId){
                            return TrRoute.get({ id: $stateParams.routeId }).$promise;
                        }else{
                            return null
                        }
                        
                    }]
                }
            })

        .state('tr-section.workflow', {
            url: '/work-flow',
            data: {
                authorities: ['ROLE_USER_ADMIN', 'ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tr-section/tr-section-work-flow.html',
                    controller: 'TrSectionWorkFlowController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                    return {
                        description: $stateParams.desc,
                        createDate: null,
                        updateDate: null,
                        pinLat: parseFloat($stateParams.lat),
                        pinLong: parseFloat($stateParams.lng),
                        address: null,
                        escalated: null,
                        status: null,
                        id: null,
                        sectionImages: []
                    };
                }]
            }
        })

        .state('tr-section.import', {
                parent: 'tr-section',
                url: '/import',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-section/tr-section-import.html',
                        controller: 'TrSectionImportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            sectionImages: []
                        };
                    }
                }

            })
            .state('tr-section.edit', {
                parent: 'tr-section',
                url: '/Edit/{id}/{routeId}',
                data: {
                    authorities: ['SECTION_EDIT'],
                    pageTitle: 'trakeyeApp.section.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-section/tr-section-dialog.html',
                        controller: 'TrSectionDialogController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    entity: ['$stateParams', 'TrSection', function ($stateParams, TrSection) {
                        return TrSection.get({ id: $stateParams.id }).$promise;
                    }],


                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'tr-section',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }],

                    route : ['$stateParams', 'TrRoute', function ($stateParams, TrRoute) {

                        if($stateParams.routeId){
                            return TrRoute.get({ id: $stateParams.routeId }).$promise;
                        }else{
                            return null
                        }
                        
                    }]
                }
            })

            .state('tr-section.delete', {
                parent: 'tr-section',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tr-section/tr-section-delete-dialog.html',
                        controller: 'TrSectionDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TrSection', function (TrSection) {
                                return TrSection.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tr-section', null, { reload: 'tr-section' });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tr-section.fibercore', {
                parent: 'tr-section',
                url: '/fibercore',
                data: {
                    authorities: ['ROLE_USER_ADMIN', 'ROLE_HOD', 'ROLE_CITY_MANAGER','ROLE_BA', 'ROLE_CITY_PLANNER', 'ROLE_ASSISTANT_MANAGER','ROLE_OA', 'ROLE_TEAM_LEADER', 'ROLE_FE','ROLE_NETWORK_ENGINEER', 'ROLE_FRT', 'ROLE_PATROLLER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-section/tr-section-fiber-core.html',
                        controller: 'TrSectionFiberCoreController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            createDate: null,
                            updateDate: null,
                            pinLat: null,
                            pinLong: null,
                            address: null,
                            escalated: null,
                            status: null,
                            id: null,
                            sectionImages: []
                        };
                    }
                }

            })

            .state('show-hide-section', {
                parent: 'report',
                url: '/show-hide-section',
                data: {
                    authorities: ['ROLE_USER_ADMIN'],
                    pageTitle: 'trakeyeApp.report.generic-report'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-section/show-hide-section.html',
                        controller: 'ShowHideSectionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reports');
                        $translatePartialLoader.addPart('logSource');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })


            .state('tr-section.materialTxndialog', {
                parent: 'tr-section',
                url: '/materialTxn/{entityName}/{entityId}/{id}/{sectionId}',
                data: {
                    authorities: ['MATERIALTX_CREATE','MATERIALTX_EDIT']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-section/material-txn.dialog.html',
                        controller: 'MaterialTxnDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    
                    entityId :  ['$stateParams', function ($stateParams) {
                        if($stateParams.entityId){ 
                            return $stateParams.entityId
                        }else{
                            return null
                        }
                    }],

                    entity: ['$stateParams', function ($stateParams) {
                        return $stateParams.id 
                    }]  
                }
            })

            .state('tr-section.resourceTxndialog', {
                parent: 'tr-section',
                url: '/resourceTxn/{entityName}/{entityId}/{id}/{sectionId}',
                data: {
                    authorities: ['RESOURCETX_CREATE']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tr-section/resource-txn.dialog.html',
                        controller: 'ResourceTxnDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entityId :  ['$stateParams', function ($stateParams) {
                        if($stateParams.entityId){ 
                            return $stateParams.entityId
                        }else{
                            return null
                        }
                    }],

                    entity: ['$stateParams', function ($stateParams) {
                        return $stateParams.id 
                    }]    
                }
            });
    }
})();